import React from 'react';
import { useConnectionStatus } from '../context/ConnectionStatusContext';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';

const ConnectionStatusAlert: React.FC = () => {
  const { status } = useConnectionStatus();

  if (status === 'connected') {
    return null; // Don't render anything if connected
  }

  return (
    <Alert
      severity="warning"
      iconMapping={{
        warning: <WifiOffIcon fontSize="inherit" />,
      }}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.snackbar, // Ensure it's above most content
        borderTop: (theme) => `1px solid ${theme.palette.warning.dark}`,
        borderRadius: 0, // Remove border radius for full width
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', // Center content horizontally
        py: 1, // Adjust vertical padding
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />
        <Typography variant="body2" component="span">
          Connection lost. Attempting to reconnect...
        </Typography>
      </Box>
    </Alert>
  );
};

export default ConnectionStatusAlert;
